<template>
  <div class="bg-gray-100 fixed bottom-0 w-full md:hidden z-10">
    <div class="flex items-center justify-between text-gray-500 py-1">
      <a
        href="/"
        :class="{ 'text-blue-800': $store.state.currentPath == '/' }"
        class="py-1 flex-1 flex flex-col items-center justify-between">
        <svg
          id="home-icon"
          class="w-6 h-6 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512">
          <path d="M208 448V320h96v128h97.6V256H464L256 64 48 256h62.4v192z" />
        </svg>
        <span class="text-xs">Beranda</span>
      </a>
      <a
        href="/products"
        :class="{ 'text-blue-800': $store.state.currentPath == 'products' }"
        class="py-1 flex-1 flex flex-col items-center justify-between">
        <svg
          id="school-icon"
          class="w-6 h-6 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512">
          <path d="M113.5 281.2v85.3L256 448l142.5-81.5v-85.3L256 362.7l-142.5-81.5zM256 64L32 192l224 128 183.3-104.7v147.4H480V192L256 64z" />
        </svg>
        <span class="text-xs">Olimpiade</span>
      </a>
      <a
        href="/cart"
        :class="{ 'text-blue-800': $store.state.currentPath == 'cart' }"
        class="relative py-1 flex-1 flex flex-col items-center justify-between">
        <svg
          id="payment-icon"
          class="w-6 h-6 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"><path d="M202.7 341.3V170.7c0-23.5 19-42.7 42.7-42.7h197v-21.3c0-23.5-18.9-42.7-42.3-42.7H92c-23.7 0-44 18.5-44 42v300c0 23.5 20.3 42 44 42h308c23.5 0 42.3-19.2 42.3-42.7V384h-197c-23.6 0-42.6-19.2-42.6-42.7z" /><path d="M245 186v140c0 8.8 7.2 16 16 16h187c8.8 0 16-7.2 16-16V186c0-8.8-7.2-16-16-16H261c-8.8 0-16 7.2-16 16zm77.1 101.9c-19.3 1.2-35.2-14.7-34-34 1-15.9 13.9-28.8 29.9-29.9 19.3-1.2 35.2 14.7 34 34-1.1 16-14 28.9-29.9 29.9z" /></svg>
        <span class="text-xs">Pembayaran</span>
        <span
          v-if="$store.getters.userProductTotalAmount + $store.getters.pendingTransactionsTotal"
          class="absolute top-0 ml-3 rounded-full h-4 w-4 text-2xs text-white flex items-center justify-center bg-red-600">{{ $store.getters.userProductTotalAmount + $store.getters.pendingTransactionsTotal }}</span>
      </a>
      <a
        v-if="!$store.getters.auth"
        href="/login"
        :class="{ 'text-blue-800': $store.state.currentPath == 'login' }"
        class="py-1 flex-1 flex flex-col items-center justify-between">
        <svg
          id="log-in-icon"
          class="w-6 h-6 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512">
          <path d="M256 48c-42.9 0-84.2 13-119.2 37.5-34.2 24-60.2 57.2-75.1 96.1L58 192h45.7l1.9-5c8.2-17.8 19.4-33.9 33.5-48 31.2-31.2 72.7-48.4 116.9-48.4s85.7 17.2 116.9 48.4c31.2 31.2 48.4 72.7 48.4 116.9 0 44.1-17.2 85.7-48.4 116.9-31.2 31.2-72.7 48.4-116.9 48.4-44.1 0-85.6-17.2-116.9-48.4-14-14-25.3-30.1-33.5-47.9l-1.9-5H58l3.6 10.4c14.9 38.9 40.9 72.1 75.1 96.1C171.8 451.1 213 464 256 464c114.7 0 208-93.3 208-208S370.7 48 256 48z" /><path d="M48 277.4h189.7l-43.6 44.7L224 352l96-96-96-96-31 29.9 44.7 44.7H48v42.8z" />
        </svg>
        <span class="text-xs">Masuk</span>
      </a>
      <a
        v-else
        href="/profile"
        :class="{ 'text-blue-800': $store.state.currentPath == 'profile' }"
        class="relative py-1 flex-1 flex flex-col items-center justify-between">
        <svg
          id="person-icon"
          class="w-6 h-6 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512">
          <path d="M256 256c52.805 0 96-43.201 96-96s-43.195-96-96-96-96 43.201-96 96 43.195 96 96 96zm0 48c-63.598 0-192 32.402-192 96v48h384v-48c0-63.598-128.402-96-192-96z" />
        </svg>
        <span class="text-xs">Akun</span>
        <span
          v-if="$store.state.purchasedProducts.length + $store.state.giftProducts.length"
          class="absolute top-0 ml-3 rounded-full h-4 w-4 text-2xs text-white flex items-center justify-center bg-red-600">{{ $store.getters.ownedProductTotalAmount }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  mounted() {
  },
  methods: {
  }
};
</script>
